module.exports = __webpack_public_path__ + "img/nomore.10f395e5.png";